module.exports = __webpack_public_path__ + "static/img/dangan_03.44c4a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dangan_03.png
// module id = YEaL
// module chunks = 1